import actions from "./actions";

const initState = {
  gift: {},
  loading: false,
  errorMessage: null,
  message: null,
  status: null,
};

export default function createOrUpdateGiftReducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_OR_UPDATE_GIFT_REQUESTED:
      return {
        ...state,
        gift: {},
        loading: true,
      };
    case actions.CREATE_OR_UPDATE_GIFT_SUCCEEDED:
      return {
        ...state,
        gift: action.gift,
        loading: false,
      };
    case actions.CREATE_OR_UPDATE_GIFT_FAILED:
      return {
        ...state,
        gift: {},
        loading: false,
        errorMessage: action.error?.message,
        message: action.error?.message,
        status: action.error?.status,
      };
    default:
      return state;
  }
}
